import Grid from '@material-ui/core/Grid'
import MuiCheckbox from '@material-ui/core/Checkbox'
import React from 'react'
import produce from 'immer'

const SubscriptionTierSection = ({ checkBoxes, setCheckBoxes }) => {
  const handleOnToggle = (index, checked) => {
    setCheckBoxes(produce(checkBoxes, draft => {
      draft[index].checked = !checked
    }))
  }

  return (
    <Grid item xs={12} className='ph8'>
      <Grid container className='w-100 b bg-precedents-blue-10 pv6'>
        <Grid item xs={3} className='pl6'>
          <label htmlFor='tier'>Subscription tier</label>
        </Grid>
        <Grid item xs={9} className='pl8'>
          <div className='pl4'>
            {checkBoxes && checkBoxes.map(({ value, checked, label }, index) => (
              <Grid container alignItems='center' key={value}>
                <Grid item>
                  <MuiCheckbox
                    color='primary'
                    id={value}
                    type='checkbox'
                    checked={!!checked}
                    value={value}
                    inputProps={{ name: 'tiers' }}
                    onChange={() => handleOnToggle(index, checked)}
                  />
                </Grid>
                <Grid item className='tc'>
                  <label htmlFor={value}>
                    {label}
                  </label>
                </Grid>
              </Grid>
            ))}
          </div>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SubscriptionTierSection
